// extracted by mini-css-extract-plugin
export default {"queryModal":"styles_queryModal__rUygB"};